module.exports = __webpack_public_path__ + "img/hero.003cc05a.jpg";